import { render, staticRenderFns } from "./ResourceInfo.vue?vue&type=template&id=bd02b08e&scoped=true"
import script from "./ResourceInfo.vue?vue&type=script&lang=js"
export * from "./ResourceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd02b08e",
  null
  
)

export default component.exports